export default __webpack_public_path__ + "static/media/Waschbär.50b4520e.webp";